export function escapeHtmlEntities(text) {
    if (text === '') {
        return '';
    }
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
export function convertPlainTextToHtml(input) {
    // Normalize line endings first
    const escaped = escapeHtmlEntities(input.replace(/\r\n?|\n/g, '\n'));
    // Split by blank lines (two or more newlines)
    const paragraphs = escaped
        .split(/\n{2,}/)
        .map((paragraph) => paragraph.trim())
        .filter((paragraph) => paragraph.length > 0);
    return paragraphs.map((paragraph) => `<p>${paragraph.replace(/\n/g, '<br/>')}</p>`).join('');
}
/** Whether the text contains a tag; a tag name always starts with a letter, so `<5 EUR>` is not one. */
export function isLikelyHtml(text) {
    return /<[a-zA-Z][\w-]*[\s\S]*?>/.test(text) || /<\/[a-zA-Z][\w-]*>/.test(text);
}
export function upgradePlainTextToHtml(text) {
    if (!isLikelyHtml(text)) {
        return convertPlainTextToHtml(text);
    }
    return text;
}
